import { useAccountPreferences } from '~publish/contexts/AccountContext'
import type { ScheduleOption } from '~publish/contexts/AccountContext/graphqlEnums'

/**
 * Returns the user's default schedule option preference.
 */
export const useDefaultScheduleOption = (): ScheduleOption => {
  const defaultScheduleOption = useAccountPreferences()?.defaultScheduleOption

  return defaultScheduleOption ?? 'Queue'
}
